import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/footer/contact-email.svg'


const _withScopeId = n => (_pushScopeId("data-v-ac21eb04"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-placeholder col-12" }, null, -1))
const _hoisted_2 = { class: "bg-dark text-light col-12 flex-centered" }
const _hoisted_3 = { class: "container-lg d-flex flex-column flex-sm-row align-items-center justify-content-between" }
const _hoisted_4 = { class: "text-center text-sm-start mb-4 mb-sm-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "15",
  alt: "Email Address"
}, null, -1))
const _hoisted_6 = { class: "mt-2 mb-0 copyright" }
const _hoisted_7 = { class: "text-center text-sm-start mb-4 mb-sm-0" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div data-v-ac21eb04><a href=\"https://www.facebook.com/BerkartZA\" target=\"_blank\" class=\"fa-stack social-icons fa-2x\" data-v-ac21eb04><i class=\"fa-solid fa-square fa-stack-2x fa-inverse\" data-v-ac21eb04></i><i class=\"fa-brands fa-facebook-f fa-stack-1x text-dark\" data-v-ac21eb04></i></a><a href=\"https://www.instagram.com/berkartza\" target=\"_blank\" class=\"fa-stack social-icons fa-2x\" data-v-ac21eb04><i class=\"fa-solid fa-square fa-stack-2x fa-inverse\" data-v-ac21eb04></i><i class=\"fa-brands fa-instagram fa-stack-1x text-dark\" data-v-ac21eb04></i></a></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("footer", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, "© " + _toDisplayString(new Date().getFullYear()) + " Berkart", 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: {name: 'ContactUs'},
            class: "text-white d-block m-0 mb-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Contact Us")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: {name: 'TermsAndConditions', hash: ''},
            class: "text-white d-block m-0 mb-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Terms and Conditions")
            ]),
            _: 1
          })
        ]),
        _hoisted_8
      ])
    ])
  ], 64))
}